import React from "react";

const Dropdown = ({
  options,
  value,
  onChange,
  placeholder,
  required,
  name,
  disabled,
}) => {
  return (
    <select
      disabled={disabled}
      className="form-select"
      aria-label="Default select example"
      value={value || ""}
      onChange={onChange}
      name={name}
      id={name}
      required={required}
    >
      <option value="" disabled>
        {placeholder || "Select option"}
      </option>
      {options?.map((option) => (
        <option key={option?.id} value={option?.id}>
          {option?.name}
        </option>
      ))}
    </select>
  );
};

export default Dropdown;
